<template>
  <dataCard title="Total Tiempo" :fact="tiempo_total" icon="fal fa-clock" @borrar_widget="borrar_widget('Tiempo'); $emit('widget_eliminado','Tiempo')">
    <template v-slot:default>
      <v-card-title class="headline">
        Total Tiempo
      </v-card-title>
      <v-card-text>
        Fecha inicial: {{primera_fecha==null ? "" : primera_fecha.toLocaleDateString()}}<br>
        Fecha final: {{ultima_fecha==null ? "" : ultima_fecha.toLocaleDateString()}}<br>
      </v-card-text>
    </template>
  </dataCard>
</template>

<script>
import DataCard from "@/components/cards/DataCard.vue";
import apiExtract from "@/api/modules/extract";
import { mapActions } from 'vuex';
export default {
  data(){
    return {
      primera_fecha:null,
      ultima_fecha:null,
    };
  },
  components:{
    DataCard
  },
  methods:{
    getData(){
      apiExtract.getAllElementsCounts(this.$route.query.process_id)
      .then((resp)=>{
          if(resp){
            this.total_elementos = resp.data.total;
            this.primera_fecha = new Date(resp.data.init_date.split("-05:00")[0]);
            this.ultima_fecha = new Date(resp.data.end_date.split("-05:00")[0]);
            this.totales_elementos = resp.data.total_elements;
          }
      })
    },
    ...mapActions({
      borrar_widget: 'auth/removeWidget'
    })
  },
  computed:{
    tiempo_total(){
      let diffDays = Math.ceil(Math.abs(this.ultima_fecha - this.primera_fecha) / (1000 * 60 * 60 * 24));
      if (diffDays>=30) {
        let diffMonths = Math.floor(diffDays/30)
        diffDays = diffDays % 30
        return diffMonths+" meses y "+diffDays+" días";
      }
      return diffDays+" días";
    }
  }
}
</script>

<style >
</style>
